import { get, post } from "@/utils/request";
import { encrypt } from "@/utils/jsencrypt";

/**
 * @description 用户登录地址
 */

export default {
  /**
   * @description 登录
   * @param {*} params 登录参数 {}
   */
  login(params) {
    params.password = encrypt(params.password);
    return post("/ylb_login", params);
  },

  // 注册
  doApply(params) {
    return post(`/wechat/tourist/doApply`, params);
  },

  // 获取用户信息
  getUserInfo(params) {
    return get(`/getInfo`, params);
  },
  
};
